var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c("span", { staticClass: "mb-3" }, [
        _vm._v(
          "Caso deseje enviar para cidades específicas, selecione-as abaixo."
        )
      ]),
      _vm._v(" "),
      _c("v-autocomplete", {
        attrs: {
          chips: "",
          dense: "",
          filled: "",
          multiple: "",
          clearable: "",
          "cache-items": "",
          "deletable-chips": "",
          "item-value": "id",
          placeholder: "Começe digitando o nome...",
          "prepend-inner-icon": "mdi-map-search-outline",
          value: _vm.cities,
          items: _vm.foundCities,
          "item-text": _vm.cityAndState,
          "close-on-content-click": false,
          "search-input": _vm.search
        },
        on: {
          input: _vm.setCities,
          "update:search-input": [
            _vm.debounce,
            function($event) {
              _vm.search = $event
            }
          ],
          "update:searchInput": function($event) {
            _vm.search = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59ddd691", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59ddd691","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/Send/Steps/Cities.vue
// module id = null
// module chunks = 